import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [me, setMe] = useState(null);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      setMe(data);
      if (data.role !== "pending") {
        const s = await api.get("/integrations/status");
        setStatus(s.data);
      }
    } catch (e) {
      setError(e?.response?.status || "error");
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <AppCtx.Provider value={{ me, setMe, status, refresh, error, isAdmin: me?.role === "admin" }}>{children}</AppCtx.Provider>;
}
